import CardTitle from "ds/components/Card/components/Title";
import { Edit } from "components/icons/generated";
import ListEntitiesItemDescription from "components/ListEntitiesItem/Description";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";
import useTypedContext from "hooks/useTypedContext";
import Timestamp from "components/Timestamp";
import CardCollapsibleToggle from "ds/components/Card/Collapsible/components/Toggle";
import CardHeader from "ds/components/Card/components/Header";

import { ContextContext } from "../../Context";
import styles from "./styles.module.css";
import { ContextMountedFilesListItemHeaderProps } from "./types";
import { COLUMN_ORDER_MOUNTED_FILES_LIST_ITEM } from "../../constants";

const ContextMountedFilesListItemHeader = ({
  children,
  item,
  onOpenEditDrawer,
  isCollapsed,
}: ContextMountedFilesListItemHeaderProps) => {
  const { canUpdateContext } = useTypedContext(ContextContext);
  return (
    <CardHeader align="center" role="row">
      <Box
        grid
        role="rowheader"
        gridTemplate={COLUMN_ORDER_MOUNTED_FILES_LIST_ITEM}
        zeroMinWidth
        align="center"
        gap="large"
        fullWidth
      >
        <Box gap="medium" align="start">
          <CardCollapsibleToggle ariaLevel={3} ariaLabel={`/mnt/workspace/${item?.id}`} />
          <Box direction="column" zeroMinWidth>
            <Box gap="medium" align="center" className={styles.titleWrapper}>
              <CardTitle tag="span" className={styles.title} align="center">
                <Box>
                  <Typography tag="span" variant="p-body3" color="secondary">
                    /mnt/workspace/
                  </Typography>
                  <TextEllipsis tooltip={item?.id} tooltipWidthMode="maxWidthSm">
                    {(props) => (
                      <Typography tag="span" variant="p-t7" {...props}>
                        {!item.id ? "New file" : item.id}
                      </Typography>
                    )}
                  </TextEllipsis>
                </Box>
              </CardTitle>
              {!isCollapsed && (
                <ButtonIcon
                  icon={Edit}
                  onPress={onOpenEditDrawer}
                  variant="ghost"
                  disabled={!canUpdateContext.result}
                  forceTooltip={!!canUpdateContext.message}
                >
                  {canUpdateContext.message || "Edit"}
                </ButtonIcon>
              )}
            </Box>

            {item.description && (
              <ListEntitiesItemDescription id={item.id} description={item.description} />
            )}
          </Box>
        </Box>
        <Typography role="cell" variant="p-body3" tag="p">
          {item.writeOnly ? "Secret" : "Plain"}
        </Typography>

        <Box role="cell" align="center">
          {item.createdAt && <Timestamp variant="p-body3" timestamp={item.createdAt} />}
        </Box>

        {children}
      </Box>
    </CardHeader>
  );
};

export default ContextMountedFilesListItemHeader;
